import React, { useState } from "react";
const galleryData = [
  {
    id: 1,
    images: [
      "/images/velvetavenuerockbank/image1.jpg",
      "/images/velvetavenuerockbank/image01.jpg",
      "/images/velvetavenuerockbank/image2.jpg",
      "/images/velvetavenuerockbank/image3.jpg",
    ],
    title: "VelvetAvenue Rock Bank",
    description: "Experience breathtaking landscapes captured from around the world.",
  },
  {
    id: 2,
    images: [
      '/images/30westbournestreetstrathtulloh/image (1).jpg',
      '/images/30westbournestreetstrathtulloh/image (2).jpg',
      '/images/30westbournestreetstrathtulloh/image (3).jpg',
      '/images/30westbournestreetstrathtulloh/image (4).jpg'
    ],
    title: "WestBourneStreet",
    description: "Discover the elegance and design of modern architecture and cityscapes.",
  },
  {
    id: 3,
    images: [
      "/images/Lot2226BoothRoadMMaddingley/Lot 2226 img 1.jpg",
      "/images/Lot2226BoothRoadMMaddingley/Lot 2226 img 2.jpg",
      "/images/Lot2226BoothRoadMMaddingley/Lot 2226 img 3.jpg",
      "/images/Lot2226BoothRoadMMaddingley/Lot 2226 img 4.jpg"],
    title: "Lot2226",
    description: "Get close to nature with wildlife photography that captures life in the wild.",
  },
  {
    id: 4,
    images: ["/images/Lot2244BoothRoadMaddingley/image (1).jpg",
      "/images/Lot2244BoothRoadMaddingley/image (2).jpg",
      "/images/Lot2244BoothRoadMaddingley/image (3).jpg",
      "/images/Lot2244BoothRoadMaddingley/image (4).jpg"],
    title: "Lot2244",
    description: "Get close to nature with wildlife photography that captures life in the wild.",
  },
  {
    id: 5,
    images: ["/images/1 Edgerton Pl Maddingley-20251220T074545Z-3-001/1 Edgerton Pl Maddingley/High-10.jpg",
      "/images/1 Edgerton Pl Maddingley-20251220T074545Z-3-001/1 Edgerton Pl Maddingley/High-2.jpg",
      "/images/1 Edgerton Pl Maddingley-20251220T074545Z-3-001/1 Edgerton Pl Maddingley/High-3.jpg",
      "/images/1 Edgerton Pl Maddingley-20251220T074545Z-3-001/1 Edgerton Pl Maddingley/High-4.jpg"],
    title: "Edgerton",
    description: "Get close to nature with wildlife photography that captures life in the wild.",
  }, {
    id: 6,
    images: ["/images/20 Corrimbla Ave Epping Photos-20251220T074509Z-3-001/20 Corrimbla Ave Epping Photos/High Res-10.jpg",
      "/images/20 Corrimbla Ave Epping Photos-20251220T074509Z-3-001/20 Corrimbla Ave Epping Photos/High Res-11.jpg",
      "/images/20 Corrimbla Ave Epping Photos-20251220T074509Z-3-001/20 Corrimbla Ave Epping Photos/High Res-12.jpg",
      "/images/20 Corrimbla Ave Epping Photos-20251220T074509Z-3-001/20 Corrimbla Ave Epping Photos/High Res-13.jpg"],
    title: "Corrimbla",
    description: "Get close to nature with wildlife photography that captures life in the wild.",
  }, {
    id: 7,
    images: ["/images/30 Hamish Road Darley-20251220T074501Z-3-001/30 Hamish Road Darley/A Web-10.jpg",
      "/images/30 Hamish Road Darley-20251220T074501Z-3-001/30 Hamish Road Darley/A Web-11.jpg",
      "/images/30 Hamish Road Darley-20251220T074501Z-3-001/30 Hamish Road Darley/A Web-12.jpg",
      "/images/30 Hamish Road Darley-20251220T074501Z-3-001/30 Hamish Road Darley/A Web-13.jpg"
    ],
    title: "Hamish",
    description: "Get close to nature with wildlife photography that captures life in the wild.",
  }, {
    id: 8,
    images: ["/images/31 Freedom Dr Mt Duneed-20251220T074458Z-3-001/31 Freedom Dr Mt Duneed/High Res-10.jpg",
      "/images/31 Freedom Dr Mt Duneed-20251220T074458Z-3-001/31 Freedom Dr Mt Duneed/High Res-11.jpg",
      "/images/31 Freedom Dr Mt Duneed-20251220T074458Z-3-001/31 Freedom Dr Mt Duneed/High Res-12.jpg",
      "/images/31 Freedom Dr Mt Duneed-20251220T074458Z-3-001/31 Freedom Dr Mt Duneed/High Res-13.jpg"
    ],
    title: "Freedom",
    description: "Get close to nature with wildlife photography that captures life in the wild.",
  }, {
    id: 9,
    images: ["/images/42 Sloop St Tarneit-20251220T074453Z-3-001/42 Sloop St Tarneit/High-10.jpg",
      "/images/42 Sloop St Tarneit-20251220T074453Z-3-001/42 Sloop St Tarneit/High-11.jpg",
      "/images/42 Sloop St Tarneit-20251220T074453Z-3-001/42 Sloop St Tarneit/High-12.jpg",
      "/images/42 Sloop St Tarneit-20251220T074453Z-3-001/42 Sloop St Tarneit/High-14.jpg"
    ],
    title: "Tarneit",
    description: "Get close to nature with wildlife photography that captures life in the wild.",
  }, {
    id: 10,
    images: ["/images/68 Castlecrag street Strathtulloh-20251220T074448Z-3-001/68 Castlecrag street Strathtulloh/High-10.jpg",
      "/images/68 Castlecrag street Strathtulloh-20251220T074448Z-3-001/68 Castlecrag street Strathtulloh/High-11.jpg",
      "/images/68 Castlecrag street Strathtulloh-20251220T074448Z-3-001/68 Castlecrag street Strathtulloh/High-12.jpg",
      "/images/68 Castlecrag street Strathtulloh-20251220T074448Z-3-001/68 Castlecrag street Strathtulloh/High-13.jpg"],
    title: "Castlecrag",
    description: "Get close to nature with wildlife photography that captures life in the wild.",
  }, {
    id: 11,
    images: ["/images/Lot 240 Leaf Way, Officer Photos + Landscaping-20251220T074438Z-3-001/Lot 240 Leaf Way, Officer Photos + Landscaping/High-10.jpg",
      "/images/Lot 240 Leaf Way, Officer Photos + Landscaping-20251220T074438Z-3-001/Lot 240 Leaf Way, Officer Photos + Landscaping/High-11.jpg",
      "/images/Lot 240 Leaf Way, Officer Photos + Landscaping-20251220T074438Z-3-001/Lot 240 Leaf Way, Officer Photos + Landscaping/High-12.jpg",
      "/images/Lot 240 Leaf Way, Officer Photos + Landscaping-20251220T074438Z-3-001/Lot 240 Leaf Way, Officer Photos + Landscaping/High-13.jpg"],
    title: "LeafWay",
    description: "Get close to nature with wildlife photography that captures life in the wild.",
  }, {
    id: 12,
    images: ["/images/Lot 1303 Aria Street Clyde-20251220T074033Z-3-001/Lot 1303 Aria Street Clyde/High Res-10.jpg",
      "/images/Lot 1303 Aria Street Clyde-20251220T074033Z-3-001/Lot 1303 Aria Street Clyde/High Res-11.jpg",
      "/images/Lot 1303 Aria Street Clyde-20251220T074033Z-3-001/Lot 1303 Aria Street Clyde/High Res-12.jpg",
      "/images/Lot 1303 Aria Street Clyde-20251220T074033Z-3-001/Lot 1303 Aria Street Clyde/High Res-13.jpg"
    ],
    title: "Clyde",
    description: "Get close to nature with wildlife photography that captures life in the wild.",
  }, {
    id: 13,
    images: ["/images/Lot 1347 Tesla Road Rockbank-20251220T074132Z-3-001/Lot 1347 Tesla Road Rockbank/A Web-11.jpg",
      "/images/Lot 1347 Tesla Road Rockbank-20251220T074132Z-3-001/Lot 1347 Tesla Road Rockbank/A Web-12.jpg",
      "/images/Lot 1347 Tesla Road Rockbank-20251220T074132Z-3-001/Lot 1347 Tesla Road Rockbank/A Web-13.jpg",
      "/images/Lot 1347 Tesla Road Rockbank-20251220T074132Z-3-001/Lot 1347 Tesla Road Rockbank/A Web-14.jpg"
    ],
    title: "RockBank",
    description: "Get close to nature with wildlife photography that captures life in the wild.",
  },
  {
    id: 14,
    images: ["/images/Waterfern Fraser Rise-20251220T074229Z-3-001/Waterfern Fraser Rise/High Res-1.jpg",
      "/images/Waterfern Fraser Rise-20251220T074229Z-3-001/Waterfern Fraser Rise/High Res-11.jpg",
      "/images/Waterfern Fraser Rise-20251220T074229Z-3-001/Waterfern Fraser Rise/High Res-12.jpg",
      "/images/Waterfern Fraser Rise-20251220T074229Z-3-001/Waterfern Fraser Rise/High Res-13.jpg"
    ],
    title: "Waterfern",
    description: "Get close to nature with wildlife photography that captures life in the wild.",
  },
];

export default function GalleryFull() {
  const [isOpen, setIsOpen] = useState(false);
  const [currentCardIndex, setCurrentCardIndex] = useState(0);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [touchStartX, setTouchStartX] = useState(0);

  const openModal = (cardIndex) => {
    setCurrentCardIndex(cardIndex);
    setCurrentImageIndex(0);
    setIsOpen(true);
  };

  const closeModal = () => setIsOpen(false);

  const prevImage = () => {
    const images = galleryData[currentCardIndex].images;
    setCurrentImageIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const nextImage = () => {
    const images = galleryData[currentCardIndex].images;
    setCurrentImageIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  // Touch events for swipe
  const handleTouchStart = (e) => setTouchStartX(e.touches[0].clientX);
  const handleTouchEnd = (e) => {
    const diff = touchStartX - e.changedTouches[0].clientX;
    if (diff > 50) nextImage();
    else if (diff < -50) prevImage();
  };

  return (
    <section className="gallery-section">

      <div className="gallery-grid">
        {galleryData.map((card, index) => (
          <div className="gallery-card" key={card.id}>
            <div className="card-image">
              <img src={card.images[0]} alt={card.title} />
            </div>
            <div className="card-content">
              <h2>{card.title}</h2>
              <p>{card.description}</p>
              <button className="contact-btn" onClick={() => openModal(index)}>
                Learn More
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* Modal */}
      {isOpen && (
        <div className="modal-overlay" onClick={closeModal}>
          <div
            className="modal-content"
            onClick={(e) => e.stopPropagation()}
            onTouchStart={handleTouchStart}
            onTouchEnd={handleTouchEnd}
          >
            <button className="modal-close" onClick={closeModal}>
              &times;
            </button>
            <button className="modal-prev" onClick={prevImage}>
              &#10094;
            </button>
            <img
              src={galleryData[currentCardIndex].images[currentImageIndex]}
              alt={galleryData[currentCardIndex].title}
            />
            <button className="modal-next" onClick={nextImage}>
              &#10095;
            </button>
            <div className="modal-caption">
              <h2>{galleryData[currentCardIndex].title}</h2>
              <p>{galleryData[currentCardIndex].description}</p>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
